<!--评论组件-->
<template>
    <section id="choiceness" >
            <!--评论头部总评分等信息-->
            <div v-if="choiceness" class="head">
               <h4>精选评论（{{choiceness.total}}）</h4>
            </div>
            <ul class="messiges">
              <template v-for="index in length">
                <li v-if="choiceness"  :key="index">
                    <div class="userinfo">
                        <img v-if="choiceness.lists[index-1].image" :src="choiceness.lists[index-1].image" alt="">
                        <img  src='../../assets/img/food_businessmen_logo@2x.png' v-else alt="">
                        <div>
                            <p>{{choiceness.lists[index-1]["nickName"]}} <span>{{choiceness.lists[index-1]['createTime'] | dateFormat('YYYY.MM.DD') }}</span></p>
                        </div>
                    </div>
                    <div class="info">
                        <!--评论内容-->
                        <p>{{listsInfo[index-1].content}}
                            <span v-if="listsInfo[index-1]['flage']">
                                  <a href="javascript:;" v-if="listsInfo[index-1]['content'].length<=54" @click="getfullText(index-1)">查看全文</a>
                                  <a href="javascript:;" v-else @click="packUp(index-1)">收起</a>
                            </span>
                        </p>
                    </div>
                </li>
              </template>
            </ul>
        <!--查看更多评论-->
        <p class="more" v-if="choiceness.total>3"><a href="javascript:;" @click.prevent="toAll()">查看更多评论</a></p>
    </section>
</template>

<script>
    import { fetchChoiceComments} from '../../common/api/homePage';

    export default {
        data(){
            return {
                listsInfo:[],
                length:3,
                choiceness:'',
                fullPath:''
            }
        },
        props: ['magazineId','page','size','commentToken', 'loaded'],
        created() {
            this.fullPath = this.$route.path+'all';
            if (this.loaded){
                this.getComments(this.magazineId,this.page,this.size,this.commentToken.token);
            }
        },
        watch:{
            commentToken(curVal){
                if(curVal && curVal.token){
                    fetchChoiceComments(+this.magazineId,1,3,curVal.token).then((rep) => {
                        if(rep.data.code === 0){
                            let obj = {
                                total:rep.data.data.count,
                                lists:rep.data.data.magazineCommentDto
                            };
                            this.choiceness = obj;
//                            this.$nextTick(() => { this.choiceness.total = rep.data.data.count; });
//                            this.$nextTick(() => { this.choiceness.lists = rep.data.data.magazineCommentDto; });
                            this.getlistsInfo();
                        }
                    })
                }
            },
            loaded () {
                this.getComments(this.magazineId,this.page,this.size,this.commentToken);
            }
        },
        methods:{
            toAll () {
                sessionStorage.setItem('k',this.commentToken.token);
                this.$router.push({name:'all'});
            },
            getComments(id,page,size,token){
                let myToken = token.token?token.token:token;
                    fetchChoiceComments(+id,page,size,myToken).then((rep) => {
                        if(rep.data.code === 0){
                            let obj = {
                                total:rep.data.data.count,
                                lists:rep.data.data.magazineCommentDto
                            };
                            this.choiceness = obj;
                            this.getlistsInfo();
                        }
                    })
            },
            getlistsInfo(){
                let data = this.choiceness.lists;
                this.length = this.choiceness.lists.length>=this.choiceness.length?
                this.choiceness.length:this.choiceness.lists.length;
                data.map((val,index)=>{
                this.listsInfo[index] = this.disposeText(val);
                });
            },
            disposeText(val){
                var obj={};
                if(val.content.length>51){
                    obj.content= val.content.substr(0,51)+"...";
                    obj.flage = true;
                    return  obj;
                }else{
                    obj.content=val.content;
                    obj.flage = false;
                    return  obj;
                }
            },
            getfullText(index){
//                方法用于将所有可枚举的属性的值从一个或多个源对象复制到目标对象。它将返回目标对象。
                let listItem = Object.assign({}, this.listsInfo[index], {content: this.choiceness.lists[index].content});
                this.$set(this.listsInfo, index, listItem);
            },
            packUp(index){
                let listItem = Object.assign({}, this.listsInfo[index], {content:this.disposeText(this.choiceness.lists[index]).content });
                this.$set(this.listsInfo, index, listItem);
            }
        }
    }
</script>

<style lang="scss">
    @import '../../assets/css/px2rem.scss';
    #choiceness{
        margin-bottom: px2rem(18);
        div.head{
            height:px2rem(44);
            font-size: px2rem(14);
            color: #333;
            line-height: px2rem(44);
            border-bottom: px2rem(1) solid #eee;
            h4{
                padding-left: px2rem(12);
            }
            }
        ul.messiges{
            li{
                overflow: hidden;
                padding:0 px2rem(12);
                background-color: #fff;
                div.userinfo{
                    height:px2rem(71);
                    border-top:1px solid #EEEEEE;
                    img{
                        margin:px2rem(12) px2rem(12) px2rem(5) 0;
                        width:px2rem(54);
                        height:px2rem(54);
                        border-radius: 50%;
                    }
                    div{
                        height:100%;
                        float: right;
                        width:px2rem(285);
                        padding-top: px2rem(21);
                        p{
                            font-size: px2rem(16);
                            color: #333333;
                            margin-bottom: px2rem(4);
                            span{
                                float: right;
                                text-align: right;
                                font-size: px2rem(12);
                                color: #999999;
                            }
                        }
                    }
                }
                div.info{
                    float: right;
                    width:px2rem(285);
                    margin-top: px2rem(-25);
                    p{
                        font-size: px2rem(14);
                        line-height: px2rem(20);
                        margin-bottom: px2rem(24.6);
                        color:#666;
                        a{
                            color:#FF4A2A;
                        }
                    }

                }
            }
        }
        p.more{
            height:px2rem(44);
            text-align: center;
            font-size: px2rem(14);
            line-height: px2rem(44);
            color:#333;
        }
        }
</style>
